import React from 'react';
import { Modal, Table, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import apiClient from 'api/client';
import { toast } from 'react-toastify';
import { getTenantFromToken } from 'utils/routeUtils';

const DynamicModal = ({ show, onClose, selectedModalData }) => {
  const isTableData =
    Array.isArray(selectedModalData?.extra?.data) &&
    selectedModalData?.extra?.data?.length > 0;
  const isOnlyTable =
    selectedModalData?.extra?.table &&
    Array.isArray(selectedModalData?.extra?.table) &&
    selectedModalData?.extra?.table?.length > 0;
  const navigate = useNavigate();
  const tenant = getTenantFromToken();
  const topButtons = selectedModalData?.modalButtons?.topButtons || [];
  const bottomButtons = selectedModalData?.modalButtons?.bottomButtons || [];
  const tns_tenant = '03534add672340809e2c70314b1ce20e';
  const handleButtonClick = async (btn, tenant, onClose) => {
    try {
      if (btn && btn.endpoint) {
        const url = `/digitization/v1/${tenant}${btn.endpoint}`;
        const response = await apiClient.patch(url);
        onClose();
        toast.success('Approval status updated successfully!');
      }
    } catch (error) {
      toast.error('Failed to Update Status!');
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title className="mb-0">
            {selectedModalData?.extra?.title}
          </Modal.Title>

          {topButtons?.length > 0 && (
            <div className="d-flex align-items-center me-6">
              {topButtons
                .filter(btn => btn.enabled)
                .map((btn, index) => (
                  <Button
                    key={index}
                    variant="outline-primary"
                    onClick={() => {
                      if (btn.buttonName.toLowerCase() === 'edit') {
                        const Id = selectedModalData?.id;
                        navigate(`/${tenant}${btn.redirectPath}/${Id}`);
                      }
                    }}
                    className="ms-2"
                  >
                    {btn.buttonName}
                  </Button>
                ))}
            </div>
          )}
        </div>
      </Modal.Header>
      <Modal.Body className="overflow-auto p-3" style={{ maxHeight: '70vh' }}>
        {/* {topButtons?.length > 0 && (
          <div className="d-flex justify-content-end mb-2 me-6">
            {topButtons
              ?.filter(btn => btn.enabled) // Ensure only enabled buttons are shown
              .map((btn, index) => (
                <Button
                  key={index}
                  variant="outline-primary"
                  onClick={() => {
                    if (btn.buttonName.toLowerCase() === 'edit') {
                      const Id = selectedModalData?.id; // Extract the ID
                      navigate(`/${tenant}${btn.redirectPath}/${Id}`);
                    }
                  }}
                  className="ms-2"
                >
                  {btn.buttonName}
                </Button>
              ))}
          </div>
        )} */}
        {isOnlyTable ? (
          <Table striped bordered hover responsive>
            <thead className="bg-200 text-900 text-nowrap align-middle">
              <tr>
                {Object.keys(selectedModalData?.extra?.data[0]).map(key => {
                  const isUpperCase = key === key.toUpperCase();
                  const formattedKey = isUpperCase
                    ? key
                    : key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
                  return (
                    <th key={key} className="p-2">
                      {formattedKey}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {selectedModalData?.extra?.table.map((row, index) => (
                <tr key={index}>
                  {Object.entries(row).map(([key, value], i) => (
                    <td key={i}>
                      {typeof value === 'object' && value !== null ? (
                        <ul className="ps-3 mb-0">
                          {Object.entries(value).map(
                            ([subKey, subValue], j) => (
                              <li key={j}>
                                <strong>{subKey}:</strong> {subValue}
                              </li>
                            )
                          )}
                        </ul>
                      ) : (
                        value
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <div className="container">
              <div className="row">
                {Object.entries(selectedModalData)
                  .filter(
                    ([key]) =>
                      key !== 'extra' &&
                      key !== 'action' &&
                      key !== 'id' &&
                      key !== 'modalButtons'
                  )
                  .map(([key, value], index) => {
                    const labelText = key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, char => char.toUpperCase());

                    return (
                      <div key={index} className="col-md-6 mb-2">
                        <div style={{ color: '#000' }}>
                          <span style={{ fontWeight: 'bold' }}>
                            {labelText}:
                          </span>{' '}
                          <span style={{ fontWeight: 'normal' }}>
                            {Array.isArray(value)
                              ? value.join(', ')
                              : typeof value === 'string' &&
                                value.includes('<a') &&
                                value.includes('href=')
                              ? (() => {
                                  const match = value.match(
                                    /<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>/i
                                  );
                                  if (match) {
                                    const [, href, text] = match;
                                    return (
                                      <a
                                        href={href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          textDecoration: 'underline',
                                          color: '#000'
                                        }}
                                      >
                                        {text}
                                      </a>
                                    );
                                  }
                                  return value;
                                })()
                              : value}
                          </span>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {isTableData && (
              <div className="mt-3">
                <Table striped bordered hover responsive>
                  <thead className="bg-200 text-600 text-nowrap align-middle">
                    <tr>
                      {Object.keys(selectedModalData?.extra?.data[0]).map(
                        key => {
                          const isUpperCase = key === key.toUpperCase();
                          const formatKey = key => {
                            // Capitalize after space or comma
                            return key.replace(
                              /(?:^|[ ,])([a-z])/g,
                              (match, p1) => match.replace(p1, p1.toUpperCase())
                            );
                          };
                          const formattedKey = isUpperCase
                            ? key
                            : formatKey(key);
                          return (
                            <th key={key} className="p-2">
                              {formattedKey}
                            </th>
                          );
                        }
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {selectedModalData?.extra?.data.map((row, index) => (
                      <tr key={index}>
                        {Object.entries(row).map(([key, value], i) => (
                          <td key={i}>
                            {typeof value === 'object' &&
                            value !== null &&
                            !Array.isArray(value) ? (
                              <ul style={{ paddingLeft: '15px', margin: 0 }}>
                                {Object.entries(value).map(
                                  ([subKey, subValue], j) => (
                                    <li key={j}>
                                      <strong>{subKey}:</strong> {subValue}
                                    </li>
                                  )
                                )}
                              </ul>
                            ) : typeof value === 'string' ? (
                              value.replace(/,\s*$/, '') // remove trailing comma and spaces
                            ) : (
                              value
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {bottomButtons?.length > 0 &&
          bottomButtons
            ?.filter(btn => btn.enabled) // Ensure only enabled buttons are shown
            .map((btn, index) => (
              <Button
                key={index}
                variant={btn?.variant || 'outline-primary'}
                onClick={() => {
                  handleButtonClick(btn, tns_tenant, onClose);
                }}
                className="ms-2"
              >
                {btn.buttonName}
              </Button>
            ))}
      </Modal.Footer>
    </Modal>
  );
};

DynamicModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedModalData: PropTypes.object
};

export default DynamicModal;
